export default "/images/bar-chart-2.svg?482eeef7b65a401467bbd78bcb9c82da";